import {createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized} from "vue-router";
import status from "@/views/status";
import {session} from "@/model/session";
import login from "@/views/login";
import main from "@/views/main";
import merchant from "@/views/merchant";
import service from "@/views/service";
import account from "@/views/account";
import brand from "@/views/brand";
import activity from "@/views/activity/activity";
import editor from "@/views/editor";

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [...login, ...main, ...merchant, ...activity, ...editor, ...brand, ...service, ...account, ...status, {
        path: '/:pathMatch(.*)',
        redirect: () => ({path: '/status/404'})
    }]
})

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
    // 只做登录守卫
    // console.log('router beforeEach:', to)
    if (session.agent) to.meta.agent = session.agent;
    if (to.meta.auth) {
        // 没登录且访问内部页，转向登录页
        if (!session.agent && to.name !== 'login') next({name: 'login'})
        // 没有品牌访问内部页面，转向首页
        else if (session.agent?.active.brands.length == 0 && to.path != '/') next('/')
        else if (to.path == '/brand') next('/brand/' + session.agent?.active.account.active_brand_id)
        else next()
    } else if (session.agent && to.name === 'login') next({name: 'main'})
    else next()
})

export default router
